import {Button} from '@/components/atoms'
import {useNavigate} from 'react-router-dom'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useIntl} from 'react-intl'

export const Actions = () => {
  const navigate = useNavigate()
  const {formatMessage} = useIntl()

  const handleCreateTier = () => {
    navigate(ROUTES.CREATE_TIER)
  }

  return (
    <section className="align-right flex justify-end gap-3">
      <Button
        uiSchema={{
          title: formatMessage({id: 'CLUB_PLUS.TIER_ACTIONS_REFRESH'}),
          disabled: true,
          variant: 'secondaryInverse',
          size: 'medium',
        }}
      />
      <Button
        handleButton={handleCreateTier}
        uiSchema={{title: formatMessage({id: 'CLUB_PLUS.TIER_ACTIONS_CREATE_TIER'}), isDark: true, size: 'medium'}}
      />
    </section>
  )
}
